"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
const crypto_1 = require("@near-js/crypto");
const types_1 = require("@near-js/types");
class ED25519Signature extends types_1.Assignable {
    constructor() {
        super(...arguments);
        this.keyType = crypto_1.KeyType.ED25519;
    }
}
class SECP256K1Signature extends types_1.Assignable {
    constructor() {
        super(...arguments);
        this.keyType = crypto_1.KeyType.SECP256K1;
    }
}
class Signature extends types_1.Assignable {
    constructor({ keyType, data }) {
        super({});
        if (keyType === crypto_1.KeyType.ED25519) {
            this.ed25519Signature = { keyType, data };
        }
        else if (keyType === crypto_1.KeyType.SECP256K1) {
            this.secp256k1Signature = { keyType, data };
        }
    }
    get signature() {
        return this.ed25519Signature || this.secp256k1Signature;
    }
    get signatureType() {
        return this.signature.keyType;
    }
    get data() {
        return this.signature.data;
    }
}
exports.Signature = Signature;
